import { render, staticRenderFns } from "./QueueTable.vue?vue&type=template&id=4b07f426&scoped=true"
import script from "./QueueTable.vue?vue&type=script&lang=js"
export * from "./QueueTable.vue?vue&type=script&lang=js"
import style0 from "./QueueTable.vue?vue&type=style&index=0&id=4b07f426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b07f426",
  null
  
)

export default component.exports